import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import './LoginPage.css';
import afribet from '../assets/afribet.png';
import { FaFutbol, FaBasketballBall, FaBolt, FaStar, FaEye, FaEyeSlash } from 'react-icons/fa';
import { getFriendlyError } from '../utils/errorHandler';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) { setError('Veuillez remplir tous les champs.'); return; }
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/');
    } catch (err) {
      setError(getFriendlyError(err, { 401: "Email ou mot de passe incorrect." }));
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleSocial = (provider) => {
    // Social auth not yet implemented
    setError(`La connexion via ${provider} n'est pas encore disponible.`);
  };

  return (
    <div className="lp-root">
      {/* ═══ LEFT PANEL ═══ */}
      <div className="lp-left">
        <div className="lp-left-gradient" />
        <div className="lp-balls">
          <span className="lp-ball lp-ball-1"><FaFutbol /></span>
          <span className="lp-ball lp-ball-2"><FaBasketballBall /></span>
          <span className="lp-ball lp-ball-3"><FaFutbol /></span>
          <span className="lp-ball lp-ball-4"><FaFutbol /></span>
          <span className="lp-ball lp-ball-5"><FaFutbol /></span>
        </div>

        <div className="lp-left-logo">
          <span className="lp-logo-bolt"><FaBolt /></span>
          <span className="lp-logo-text">  <div>
                      <img src={afribet} alt="Logo"  width={55}/>
                      </div>AfriBet</span>
        </div>

        <div className="lp-left-hero">
          <h1 className="lp-headline">
            PARIEZ.<br />
            <span className="lp-headline-accent">GAGNEZ.</span><br />
            RECOMMENCEZ.
          </h1>
          <p className="lp-subtext">
            La plateforme de paris sportifs premium. Cotes en temps réel, matchs en direct, bonus exclusifs.
          </p>
          <div className="lp-stats">
            <div className="lp-stat">
              <span className="lp-stat-value">2.4M+</span>
              <span className="lp-stat-label">Paris</span>
            </div>
            <div className="lp-stat-divider" />
            <div className="lp-stat">
              <span className="lp-stat-value">180K+</span>
              <span className="lp-stat-label">Joueurs</span>
            </div>
            <div className="lp-stat-divider" />
            <div className="lp-stat">
              <span className="lp-stat-value">98%</span>
              <span className="lp-stat-label">Satisfaction</span>
            </div>
          </div>
        </div>

        {/* Glassmorphism live card */}
        <div className="lp-live-card">
          <div className="lp-live-badge"><span className="lp-live-dot" /> LIVE</div>
          <div className="lp-live-league"><FaStar /> Champions League</div>
          <div className="lp-live-match">
            <div className="lp-live-team"><span className="lp-live-emoji"><FaFutbol /></span><span>Real Madrid</span></div>
            <div className="lp-live-score">
              <span className="lp-score-num">2</span>
              <span className="lp-score-sep">—</span>
              <span className="lp-score-num">1</span>
            </div>
            <div className="lp-live-team lp-live-team-right"><span>Bayern</span><span className="lp-live-emoji"><FaFutbol /></span></div>
          </div>
          <div className="lp-live-minute">67'</div>
          <div className="lp-live-odds">
            <button className="lp-odd-btn">1 — <strong>1.35</strong></button>
            <button className="lp-odd-btn">X — <strong>4.20</strong></button>
            <button className="lp-odd-btn">2 — <strong>8.50</strong></button>
          </div>
        </div>

        <div className="lp-trust">
          <div className="lp-trust-badge">🔒 SSL Sécurisé</div>
          <div className="lp-trust-badge">🏛️ Licencié</div>
          <div className="lp-trust-badge">⚡ Paiement Rapide</div>
        </div>
      </div>

      {/* ═══ RIGHT PANEL ═══ */}
      <div className="lp-right">
        <div className="lp-form-card">
          <div className="lp-right-logo">
           <span className="lp-logo-bolt"><img src={afribet} alt="Log"  width={55}/></span> 
            <span className="lp-logo-text">Afri<span className="lp-logo-accent">Bet</span></span>
          </div>

          <h1 className="lp-title">Bienvenue !</h1>
          <p className="lp-subtitle">Connectez-vous pour accéder à vos paris</p>

          <div className="lp-social">
            {/* <button className="lp-social-btn lp-google" onClick={() => handleSocial('google')}>
              <span className="lp-social-icon">
                <svg width="18" height="18" viewBox="0 0 18 18">
                  <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
                  <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
                  <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
                  <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
                </svg>
              </span>
              Continuer avec Google
            </button> */}
            {/* <button className="lp-social-btn lp-facebook" onClick={() => handleSocial('facebook')}>
              <span className="lp-social-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </span>
              Continuer avec Facebook
            </button> */}
          </div>

          <div className="lp-divider">
            <span className="lp-divider-line" />
            <span className="lp-divider-text">ou continuer avec email</span>
            <span className="lp-divider-line" />
          </div>

          <form onSubmit={handleSubmit} noValidate>
            <div className={`lp-field ${focusedField === 'email' || form.email ? 'lp-field-active' : ''}`}>
              <input type="email" id="lp-email" value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                onFocus={() => setFocusedField('email')} onBlur={() => setFocusedField(null)}
                autoComplete="email" />
              <label htmlFor="lp-email">Adresse email</label>
              <span className="lp-field-icon">📧</span>
            </div>

            <div className={`lp-field ${focusedField === 'password' || form.password ? 'lp-field-active' : ''}`}>
              <input type={showPassword ? 'text' : 'password'} id="lp-password" value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                onFocus={() => setFocusedField('password')} onBlur={() => setFocusedField(null)}
                autoComplete="current-password" />
              <label htmlFor="lp-password">Mot de passe</label>
              <button type="button" className="lp-pw-toggle" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            <div className="lp-options">
              <label className="lp-check">
                <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
                <span className="lp-checkmark" />
                <span className="lp-check-label">Se souvenir de moi</span>
              </label>
              <a href="#forgot" className="lp-forgot">Mot de passe oublié ?</a>
            </div>

            {error && <div className="lp-error-msg">{error}</div>}

            <button type="submit" className={`lp-submit ${loading ? 'lp-loading' : ''}`} disabled={loading}>
              {loading ? (<><span className="lp-spinner" />Connexion en cours...</>) : (<>Se connecter<span className="lp-arrow">→</span></>)}
            </button>
          </form>

          <p className="lp-register-link">
            Pas de compte ? <Link to="/register" className="lp-register-cta">S'inscrire gratuitement</Link>
          </p>

          <div className="lp-responsible">
            <span className="lp-responsible-badge">🔞 Jeu responsable 18+</span>
            <span className="lp-responsible-text">Jouer comporte des risques. Jouez de façon responsable.</span>
          </div>
        </div>
      </div>
    </div>
  );
}
